export default __webpack_public_path__ + "static/media/inclination.7825fcb8.png";